import { useRef, useState } from 'react';

import { lodash } from 'helpers';

interface Args {
  initialSearch?: string;
  wait?: number;
  onSearch?: (v: string) => void;
}

export const useSearchDebounce = ({
  initialSearch,
  wait = 600,
  onSearch,
}: Args = {}) => {
  const [search, setSearch] = useState<string>(initialSearch ?? '');

  const handleSearch = (v: string, isUpdateState: boolean = true) => {
    if (isUpdateState) {
      setSearch(v);
    }
    if (onSearch) {
      onSearch(v);
    }
  };

  const debouncedFunc = useRef(lodash.debounce(handleSearch, wait)).current;

  const onChangeText = (value: string) => {
    setSearch(value);
    debouncedFunc(value, false);
  };

  return {
    search,
    setSearch,
    debouncedFunc,
    onChangeText,
  };
};
